import _ from 'lodash';

export const parseNumberedLabel = (value) =>
  value && value !== 'NA' ? `# ${value}` : 'NA';

export const isNonEmptyPlainObject = (obj) =>
  _.isPlainObject(obj) && !_.isEmpty(obj);

export const isBrowser = () => typeof window !== 'undefined';
